// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const skiddo: PokeData = {
  "id": 672,
  "name": "skiddo",
  "height": 9,
  "weight": 310,
  "base_experience": 70,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "vine-whip",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "leech-seed",
    "growth",
    "razor-leaf",
    "milk-drink",
    "synthesis",
    "bulk-up",
    "leaf-blade",
    "worry-seed",
    "seed-bomb",
    "bulldoze",
    "horn-leech"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "razor-leaf",
    "synthesis",
    "bulk-up",
    "frenzy-plant",
    "solar-beam",
    "power-whip",
    "grassy-terrain",
    "wood-hammer",
    "flower-rush",
    "branch-poke",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 345,
    "item": null,
    "species": [
      {
        "name": "skiddo",
        "order": 673,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gogoat",
        "order": 674,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 672,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 59.25,
    "speed": 52,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
